module.exports = __webpack_public_path__ + "img/sheet_cogs.7ddc4499.svg";